var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{ref:"currency_input",attrs:{"type":_vm.isInputActive ? 'number' : 'text',"state":_vm.state,"disabled":_vm.disabled},on:{"blur":function($event){_vm.isInputActive = false},"focus":($evt) => {
                _vm.$emit('focus', $evt)
                _vm.isInputActive = true
            }},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }